import { USER_EVENTS } from '../../constants/events';

export const updateUser = (updatedUser = {}) => ({
	type: USER_EVENTS.UPDATE_USER,
	payload: updatedUser
});


// WEBPACK FOOTER //
// ../q-jobs/src/actions/UserActions/index.js